import { Model } from "../helpers/model";
import { Permissions } from "app/shared/helpers/permissions";
import { AdminUser } from "app/shared/models/admin-user";

export class Account extends Model {
  public accountId?: string;
  public accountType?: string;
  public externalIdentifier?: string;
  public name?: string;
  public users?: AdminUser[] | null;
  public status: string;
  public permissions?: Permissions;
  public hasChildren?: boolean;
  public childAccounts?: Account[];
  public parentAccounts?: Account[];

  public setAttributes(data: any): void {
    this.accountId = data.accountId;
    this.accountType = data.accountType;
    this.externalIdentifier = data.externalIdentifier;
    this.name = data.name;
    this.status = data.status;
    this.permissions = data.permissions ? data.permissions : new Permissions();
    this.childAccounts = data.childAccounts;
    this.parentAccounts = data.parentAccounts;
  }

  public fromJSON(json: any): void {
    this.setAttributes(json);
  }

  /**
   * returns shorten account type
   */
  public getAccountType(): string {
    if (this.externalIdentifier) {
      return this.externalIdentifier.slice(0, 1).toUpperCase();
    }
    return "-";
  }

  /**
   * Check if customer account (K) level
   */
  get isKAccount(): boolean {
    return this.getAccountType() === "K";
  }
}
